import React from 'react';
import { team } from '../../data/mock';
import { Mail, Linkedin, Phone } from 'lucide-react';

const TeamSection = () => {
  return (
    <section className="section-padding bg-[#0B0B0B]">
      <div className="container-luxury">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="heading-luxury mb-6">
            Нашият <span className="gradient-text">екип</span>
          </h2>
          <p className="text-lg text-[#A9A9A9] leading-relaxed">
            Експерти с дългогодишен опит в областта на недвижимите имоти и инвестициите
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto">
          {team.map((member, index) => (
            <div 
              key={index}
              className="card-luxury text-center group"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Team Image */}
              <div className="w-32 h-32 mx-auto mb-6 rounded-full overflow-hidden border-4 border-[#D4AF37]/20 group-hover:border-[#D4AF37] group-hover:scale-105 transition-all duration-300">
                <img 
                  src={member.image} 
                  alt={member.name}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Name & Position */}
              <h3 className="text-2xl font-serif font-semibold text-[#F6F2E8] mb-2">
                {member.name}
              </h3>
              <p className="text-[#D4AF37] font-medium mb-4 tracking-wide">
                {member.position}
              </p>

              {/* Bio */}
              <p className="text-[#A9A9A9] leading-relaxed mb-6">
                {member.bio}
              </p>

              {/* Contact Icons */}
              <div className="flex items-center justify-center space-x-4">
                <a 
                  href={`tel:${member.phone}`}
                  className="w-10 h-10 bg-[#D4AF37]/10 rounded-full flex items-center justify-center hover:bg-[#D4AF37] hover:text-[#0B0B0B] text-[#D4AF37] transition-all duration-300"
                  aria-label="Телефон"
                >
                  <Phone size={18} />
                </a>
                <a 
                  href="mailto:zaharii.stoyanov@deusestate.com"
                  className="w-10 h-10 bg-[#D4AF37]/10 rounded-full flex items-center justify-center hover:bg-[#D4AF37] hover:text-[#0B0B0B] text-[#D4AF37] transition-all duration-300"
                  aria-label="Email"
                >
                  <Mail size={18} />
                </a>
                <a 
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-[#D4AF37]/10 rounded-full flex items-center justify-center hover:bg-[#D4AF37] hover:text-[#0B0B0B] text-[#D4AF37] transition-all duration-300"
                  aria-label="LinkedIn"
                >
                  <Linkedin size={18} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
